let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("8Ned5"), load("1Scxq")]).then(() => parcelRequire('3aZBP'));